exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".map{height:30rem;width:80rem;background:#ccc}.map-icon{background:purple;border-radius:50%;border:2px solid #fff;box-shadow:0 0 4px #000}", "", {"version":3,"sources":["/../../../../../sassjs-loader/index.js!/home/vsts/work/1/s/src/components/lbMap/lbMap.scss"],"names":[],"mappings":"AAAA,KACE,aAAc,AACd,YAAa,AACb,eAAiB,CAAE,AAErB,UACE,kBAAmB,AACnB,kBAAmB,AACnB,sBAAuB,AACvB,uBAAyB,CAAE","file":"lbMap.scss","sourcesContent":[".map {\n  height: 30rem;\n  width: 80rem;\n  background: #ccc; }\n\n.map-icon {\n  background: purple;\n  border-radius: 50%;\n  border: 2px solid #fff;\n  box-shadow: 0 0 4px #000; }\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sassjs-loader!./src/components/lbMap/lbMap.scss
// module id = 378
// module chunks = 0